import { PuzzleNames } from './types';

export const addStructureDataForPuzzle = (puzzleName: PuzzleNames | null) => {
   // Try to find an existing script with the ID
  let structuredDataScript = document.getElementById('puzzle-structured-data');

  // If puzzleName is null, remove the script and exit the function
  if (puzzleName === null) {
    if (structuredDataScript) {
      structuredDataScript.remove();
    }
    return;
  }

  // If a script does not exist, create it
  if (!structuredDataScript) {
    structuredDataScript = document.createElement('script');
    structuredDataScript.id = 'puzzle-structured-data';
    structuredDataScript.setAttribute('type', 'application/ld+json');
    document.head.appendChild(structuredDataScript);
  }

  // Update the text content of the script with the new data
  const rawData: any = puzzleData[puzzleName];
  rawData["@context"] = "https://schema.org";
  rawData["@type"] = "Article";
  rawData["datePublished"] = new Date().toISOString().slice(0, 19) + "Z";
  structuredDataScript.textContent = JSON.stringify(rawData, null, 2);
};

const puzzleData = {
  arithmeglyphs: {
    "headline": "Arithmeglyphs",
    "description": "A daily logic puzzle where numbers and symbols are used to reveal a hidden code.",
    "url": "https://dailybaffle.com/arithmeglyphs"
  },
  megarubigram: {
    "headline": "Megarubigram",
    "description": "An extra-hard bi-weekly word puzzle where letter grids are flipped and rotated to form words.",
    "url": "https://dailybaffle.com/megarubigram"
  },
  morphology: {
    "headline": "Morphology",
    "description": "A daily word puzzle resembling a clued word ladder.",
    "url": "https://dailybaffle.com/morphology"
  },
  pathword: {
    "headline": "Pathword",
    "description": "A daily word puzzle where a path must be drawn to unscramble four anagrams.",
    "url": "https://dailybaffle.com/pathword"
  },
  pathword5x5: {
    "headline": "Pathword 5x5",
    "description": "An extra-hard bi-weekly word puzzle involving anagrams and spatial logic.",
    "url": "https://dailybaffle.com/pathword5x5"
  },
  rubigram: {
    "headline": "Rubigram",
    "description": "A daily word puzzle where letter grids are flipped and rotated to form words.",
    "url": "https://dailybaffle.com/rubigram"
  },
  triword: {
    "headline": "Triword",
    "description": "A daily word puzzle where you must find the fragment that uniquely completes 3 words.",
    "url": "https://dailybaffle.com/triword"
  },
  ultrarubigram: {
    "headline": "Ultrarubigram",
    "description": "A monthly, desktop-only word puzzle where a 24x24 of letter grids is flipped and rotated to form words.",
    "url": "https://dailybaffle.com/ultrarubigram"
  },
  truthsorting: {
    "headline": "Truthsorting",
    "description": "A daily logic puzzle where truths and lies must be placed in the correct order.",
    "url": "https://dailybaffle.com/truthsorting"
  },
  varyClove: {
    "headline": "Vary Clove",
    "description": "A daily word puzzle where you must decipher a mysterious answer to a very basic question.",
    "url": "https://dailybaffle.com/varyclove"
  },
};